export const CREATE_EMERGENCY_CONTACT = "CREATE_EMERGENCY_CONTACT";

export const UPDATE_EMERGENCY_CONTACT = "UPDATE_EMERGENCY_CONTACT";
